import { render, staticRenderFns } from "./HomePageSettings.vue?vue&type=template&id=2cab7a2f&scoped=true"
import script from "./HomePageSettings.vue?vue&type=script&lang=js"
export * from "./HomePageSettings.vue?vue&type=script&lang=js"
import style0 from "./HomePageSettings.vue?vue&type=style&index=0&id=2cab7a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab7a2f",
  null
  
)

export default component.exports